/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_uses_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Common uses`)
};

const es_timer_uses_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usos comunes`)
};

const de_timer_uses_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Häufige Anwendungen`)
};

const nl_timer_uses_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veelgebruikte toepassingen`)
};

const fr_timer_uses_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilisations courantes`)
};

const it_timer_uses_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usi comuni`)
};

const pt_br2_timer_uses_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usos comuns`)
};

const pt_timer_uses_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilizações comuns`)
};

const ja_timer_uses_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主な使い方`)
};

const zh_timer_uses_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`常见用途`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_uses_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_uses_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_uses_title", locale)
	if (locale === "en") return en_timer_uses_title(inputs)
	if (locale === "es") return es_timer_uses_title(inputs)
	if (locale === "de") return de_timer_uses_title(inputs)
	if (locale === "nl") return nl_timer_uses_title(inputs)
	if (locale === "fr") return fr_timer_uses_title(inputs)
	if (locale === "it") return it_timer_uses_title(inputs)
	if (locale === "pt-BR") return pt_br2_timer_uses_title(inputs)
	if (locale === "pt") return pt_timer_uses_title(inputs)
	if (locale === "ja") return ja_timer_uses_title(inputs)
	return zh_timer_uses_title(inputs)
};